export const filterIds = ['takeOffType', 'level', 'imageName'] as const;
